import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCNnF17g5Mhfw_dWH01cQWT4mmceHmrR1Y",
  authDomain: "un-maison-pour-tous.firebaseapp.com",
  projectId: "un-maison-pour-tous",
  storageBucket: "un-maison-pour-tous.firebasestorage.app",
  messagingSenderId: "249691482487",
  appId: "1:249691482487:web:8f1a5d449de32f1c4cd972",
  measurementId: "G-4RQHR66FK3",
};

export const firebaseApp = initializeApp(firebaseConfig);

export let analytics = null;
isSupported()
  .then((ok) => {
    if (ok) analytics = getAnalytics(firebaseApp);
  })
  .catch(() => {});
